import I18n from './translations';

export default class Loader {
	constructor() {
		this.bodyClass = 'js-m-page-loader--is-active';
		this.$body = $('body');
	}

	blockPageAfterClick() {
		mApp.blockPage({
			overlayColor: '#000000',
			type: 'loader',
			state: 'primary',
			message: I18n.global().pageLoaderText
		});
	}

	showAfterClick(link) {
		const that = this;

		link.on('click', function () {
			that.blockPageAfterClick();
		});
	}

	/**
	 * Special event bind for dynamic created markup with ajax
	 *
	 * @param selector - css class for detect click
	 * @param inModal - hide if link is in modal
	 */

	showAfterClickInAjax(selector, inModal) {
		const that = this;

		this.$body.on('click', selector, function () {
			if (!$(this).hasClass('disabled')) {
				that.blockPageAfterClick();

				if (inModal === true) {
					$('.modal').hide();
					$('.modal-backdrop').hide();
				}
			}
		});
	}

	removeAfterWindowLoad() {
		this.$body.removeClass(this.bodyClass);
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/classes/loader.js